export default __webpack_public_path__ + "static/media/partners-logo-hanyang-w@3x.e4fbcc5c.png";